export default {
	UPDATE_USER: 'users/update',
	CHATS: {
		MESSAGE: 'chat-message'
	}
}